import Immutable from 'immutable'

import { actionTypes } from 'actions/actionTypes'
import { checkoutConfig } from 'routes/Checkout/checkoutConstants'

const applePayErrors = [
  actionTypes.APPLE_PAY_TOKEN_CONVERSION_ERROR,
  actionTypes.APPLE_PAY_MERCHANT_VALIDATION_ERROR,
]
const paypalErrors = [actionTypes.PAYPAL_TOKEN_FETCH_FAILED, actionTypes.PAYPAL_ERROR]

const errorsToCapture = [
  actionTypes.USER_SUBSCRIBE,
  actionTypes.CHECKOUT_SIGNUP,
  actionTypes.CHECKOUT_SIGNUP_LOGIN,
  actionTypes.CHECKOUT_PAYMENT,
  actionTypes.ORDER_SAVE,
  actionTypes.CARD_TOKENIZATION_FAILED,
  actionTypes.NETWORK_FAILURE,
  actionTypes.VALID_CARD_DETAILS_NOT_PROVIDED,
  ...applePayErrors,
  ...paypalErrors,
]

const checkoutInitialState = Immutable.fromJS({
  applePay: {
    personalInfo: {
      firstName: '',
      lastName: '',
      phoneNumber: '',
    },
    deliveryAddress: {
      name: '',
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postcode: '',
    },
    deliveryInstruction: checkoutConfig.leaveBoxOptions[0],
    deliveryInstructionCustom: '',
  },
  deliveryAddresses: [],
  goustoRef: null,
  errors: {},
  applePayErrors: {},
  paypalErrors: {},
  paypalErrorsReported: false,
  lastReachedStepIndex: 0,
  passwordInfo: {
    value: '',
    errorCodes: [],
  },
  recaptchaExecutionStarted: false,
  applePayRecaptchaExecutionStarted: false,
})

export const checkoutReducers = {
  checkout: (state, action) => {
    if (!state) {
      return checkoutInitialState
    }

    switch (action.type) {
      case actionTypes.CHECKOUT_LOAD_APPLE_PAY_ENABLED_STATUS: {
        return state.set('isApplePayEnabled', action.payload)
      }

      case actionTypes.CHECKOUT_ERRORS_CLEAR: {
        return state.set('errors', checkoutInitialState.get('errors'))
      }

      case actionTypes.CHECKOUT_PAYPAL_ERRORS_CLEAR: {
        return state.set('paypalErrors', checkoutInitialState.get('paypalErrors'))
      }

      case actionTypes.APPLE_PAY_ERRORS_CLEAR: {
        return state.set('applePayErrors', checkoutInitialState.get('applePayErrors'))
      }

      case actionTypes.CHECKOUT_PAYPAL_ERRORS_REPORTED: {
        return state.set('paypalErrorsReported', true)
      }

      case actionTypes.CHECKOUT_ADDRESSES_RECEIVE: {
        const { addresses } = action
        const addressList = []
        addresses.forEach((address) => {
          addressList.push({
            id: address.id,
            labels: address.labels,
            count: address.count,
          })
        })

        return state.set('deliveryAddresses', Immutable.fromJS(addressList))
      }

      case actionTypes.CHECKOUT_SET_GOUSTO_REF: {
        const { goustoRef } = action

        return state.set('goustoRef', goustoRef)
      }

      case actionTypes.PAYMENT_SET_PAYMENT_METHOD: {
        return state.set('errors', checkoutInitialState.get('errors'))
      }

      case actionTypes.PAYMENT_SET_PAYPAL_CLIENT_TOKEN: {
        return state.deleteIn(['paypalErrors', actionTypes.PAYPAL_TOKEN_FETCH_FAILED])
      }

      case actionTypes.SAVE_APPLE_PAY_CHECKOUT_TOKEN: {
        return state.deleteIn(['applePayErrors', actionTypes.APPLE_PAY_TOKEN_CONVERSION_ERROR])
      }

      case actionTypes.ERROR: {
        if (
          Object.prototype.hasOwnProperty.call(action, 'key') &&
          Object.prototype.hasOwnProperty.call(action, 'value')
        ) {
          if (errorsToCapture.indexOf(action.key) !== -1) {
            let { value } = action

            if (value instanceof Error) {
              value = value.message
            }

            let errors

            if (applePayErrors.indexOf(action.key) !== -1) {
              errors = 'applePayErrors'
            } else if (paypalErrors.indexOf(action.key) !== -1) {
              errors = 'paypalErrors'
            } else {
              errors = 'errors'
            }

            return state.setIn([errors, action.key], value)
          }
        }

        return state
      }

      case actionTypes.CHECKOUT_STEP_INDEX_REACHED: {
        const { stepIndex } = action

        const lastReachedStepIndex = state.get('lastReachedStepIndex')
        if (stepIndex > lastReachedStepIndex) {
          return state.set('lastReachedStepIndex', stepIndex)
        }

        return state
      }

      case actionTypes.CHECKOUT_PASSWORD_VALIDATION_RULES_SET: {
        const { errors, password } = action

        let newState = state.setIn(
          ['passwordInfo', 'errorCodes'],
          errors.map((item) => item.error),
        )
        newState = newState.setIn(['passwordInfo', 'value'], password)

        return newState
      }

      case actionTypes.CHECKOUT_SIGNUP_START_RECAPTCHA_EXECUTION: {
        const { executionStarted } = action

        return state.set('recaptchaExecutionStarted', executionStarted)
      }

      case actionTypes.APPLE_PAY_START_RECAPTCHA_EXECUTION: {
        const { executionStarted } = action

        return state.set('applePayRecaptchaExecutionStarted', executionStarted)
      }

      case actionTypes.SAVE_APPLE_PAY_DELIVERY_INSTRUCTION: {
        const { deliveryInstruction } = action

        return state.setIn(['applePay', 'deliveryInstruction'], deliveryInstruction)
      }

      case actionTypes.SAVE_APPLE_PAY_DELIVERY_INSTRUCTION_CUSTOM: {
        const { deliveryInstructionCustom } = action

        return state.setIn(['applePay', 'deliveryInstructionCustom'], deliveryInstructionCustom)
      }

      case actionTypes.SAVE_APPLE_PAY_DELIVERY_ADDRESS: {
        const { deliveryAddress } = action

        return state.setIn(['applePay', 'deliveryAddress'], Immutable.Map(deliveryAddress))
      }

      case actionTypes.SAVE_APPLE_PAY_PERSONAL_INFO: {
        const { personalInfo } = action

        return state.setIn(['applePay', 'personalInfo'], Immutable.Map(personalInfo))
      }

      default: {
        return state
      }
    }
  },
}
